const WritingPageArray = [
  {
    topic: "I m Mad!",
    topicDesc:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    topicLink: "https://www.google.com/",
  },
  {
    topic: "why I m Mad!",
    topicDesc:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    topicLink: "https://www.google.com/",
  },
  {
    topic: "Give Me Job",
    topicDesc:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    topicLink: "https://www.google.com/",
  },
  {
    topic: "Modi Hai to Mumkin Hai",
    topicDesc:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    topicLink: "https://www.google.com/",
  },
];

export default WritingPageArray;
